import React, { useState,  useRef } from 'react';
import './FacilityLogo.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import getBase64 from '../../common/getBase64';
import getImageTypeFromBase64 from '../../common/getImageTypeFromBase64';
import logComponent from '../../common/logComponent';

export default function FacilityLogo({ onChange, facility }) {
  const [selectedFile, setSelectedFile] = useState('');
  const [selectedLogoBase64, setSelectedLogoBase64] = useState(null);
  const [selectedLogoLoading, setSelectedLogoLoading] = useState(false);
  const [selectedLogoError, setSelectedLogoError] = useState(false);
  const nativeFileInputRef = useRef(null);
  const { logo, name } = facility;

  if (logComponent('FacilityLogo')) { console.debug('FacilityLogo rendered'); }

  const setNativeFileInputRef = (el) => {
    if (logComponent('FacilityLogo')) { console.debug('FacilityLogo setNativeFileInputRef'); }
    nativeFileInputRef.current = el;
  }  


  const openSelectFileDialog = () => {
    if (logComponent('FacilityLogo')) { console.debug('FacilityLogo openSelectFileDialog'); }
    nativeFileInputRef.current.click();
  }

  const updateFile = (e) => {
    if (logComponent('FacilityLogo')) { console.debug('FacilityLogo updateFile'); }
    let { files } = e.target;

    if (files.length === 0) return;

    setSelectedFile(files[0]);

    onChange(files[0]);

    updateSelectedLogo(files[0]);
  }

  const updateSelectedLogo = (file) => {
    if (logComponent('FacilityLogo')) { console.debug('FacilityLogo updateSelectedLogo'); }
    setSelectedLogoLoading(true);

    getBase64(file)
      .then(
        result => {
          setSelectedLogoBase64(result);
          setSelectedLogoLoading(false);
          setSelectedLogoError(false);
        },
        error => {
          setSelectedLogoLoading(false);
          setSelectedLogoError(true);
        }
      )
  }

  const removeSelectedLogo = () => {
    if (logComponent('FacilityLogo')) { console.debug('FacilityLogo removeSelectedLogo'); }
    setSelectedFile('');
    setSelectedLogoBase64(null);


    nativeFileInputRef.current.value = null;

    onChange(null);
  }


  return (
    <div className="Facility-Logo">
    {
      logo || selectedLogoBase64 ?
      <React.Fragment>
      <img 
        className="Facility-Logo__image"
        src={`data:${selectedFile ? selectedFile.type : logo ? getImageTypeFromBase64(logo) : 'image/'};base64,${selectedLogoBase64 ? selectedLogoBase64 : logo}`} 
        alt={`Logo for ${name}`} /> 
      {
        selectedLogoBase64 &&
        <button 
          className="Facility-Logo__image-clear-button"
          onClick={removeSelectedLogo}>
          <FontAwesomeIcon className="Facility-Logo__close-icon" icon="times" />
        </button>          
      } 
      </React.Fragment> :
      <div
        className="Facility-Logo__image-placeholder">
        No image selected
      </div>
    }
      <div className="Facility-Logo__upload">
        <input 
          className="Facility-Logo__native-file-input" 
          ref={setNativeFileInputRef}
          type="file"
          onChange={updateFile}
          accept=".svg, .png, .jpg, .jpeg" />
        <div className="Facility-Logo__visible-input">
          <input 
            className="Facility-Logo__visible-input-element" 
            type="text" 
            readOnly={true}
            value={selectedFile ? selectedFile.name : ''}
              />
          <p
            className="Facility-Logo__visible-input-instructions">
            Upload photo as SVG, JPG, or PNG
          </p>
        </div>            
        <button 
          className="Facility-Logo__upload-button"
          onClick={openSelectFileDialog}>
          <FontAwesomeIcon 
            className="Facility-Logo__upload-icon"
            icon="upload" />
            Upload
        </button>
      </div>
    </div>
  );
}